import { FC } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';
import { Typography } from '@vk-hr-tek/ui/Typography';

const DEFAULT_ERROR_TEXT = 'Не удалось загрузить изображения';
const DEFAULT_RETRY_TEXT = 'Попробуйте выполнить поиск еще раз';

type NoImageProps = {
  isCircle?: boolean;
  errorText?: string;
  retryText?: string;
};

export const NoImage: FC<NoImageProps> = ({
  isCircle,
  errorText = DEFAULT_ERROR_TEXT,
  retryText = DEFAULT_RETRY_TEXT,
}) => {
  return (
    <Tooltip
      placement="top"
      title={
        <Box display="flex" flexDirection="column" gap="8">
          <Typography variant="caption" color="bg.light.primary">
            {errorText}
          </Typography>
          <Typography variant="caption" color="text.dark.secondary">
            {retryText}
          </Typography>
        </Box>
      }
    >
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        radius={isCircle ? 'round' : undefined}
        bgcolor="bg.greyscale.primary"
      >
        <Icon name="picture_slash_outline" size="20" color="stroke.secondary" />
      </Box>
    </Tooltip>
  );
};
